import { p as proxyCustomElement, H, h, d as Host } from './p-BJEvNVLM.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";

const CosmosIconNews$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconNews extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: '743f3206fd2ccbc38daaa597f651619ee88bf645', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: 'ad672106638f334317f549b9eabcf77645988706', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: '93f565757092675001f38f268b39d5c4a37206da', d: "M16.25 4a.75.75 0 0 1 .75.75v2.5h2.25c.398 0 .75.352.75.75v7.75A2.26 2.26 0 0 1 17.75 18H4.25A2.26 2.26 0 0 1 2 15.75v-11A.75.75 0 0 1 2.75 4zm-.75 1.5h-12v10.25c0 .428.322.75.75.75h11.39a2.2 2.2 0 0 1-.14-.75zm3 3.25H17v7c0 .428.322.75.75.75s.75-.322.75-.75z", fill: "currentColor" }), h("path", { key: '16556efd2f17905bff9e0fb43e55f9814087b262', d: "M10 8.25a.5.5 0 0 1-.5.5h-4a.495.495 0 0 1-.5-.5v-.5a.5.5 0 0 1 .5-.5h4a.51.51 0 0 1 .5.5zm4 3a.5.5 0 0 1-.5.5h-8a.495.495 0 0 1-.5-.5v-.5a.5.5 0 0 1 .5-.5h8a.51.51 0 0 1 .5.5zm0 3a.5.5 0 0 1-.5.5h-8a.495.495 0 0 1-.5-.5v-.5a.5.5 0 0 1 .5-.5h8a.51.51 0 0 1 .5.5z", fill: "currentColor" }))));
    }
    static get style() { return cosmosIconCss; }
}, [1, "cosmos-icon-news", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-news"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-news":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconNews$1);
            }
            break;
    } });
}

const CosmosIconNews = CosmosIconNews$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconNews, defineCustomElement };
